// extracted by mini-css-extract-plugin
export default {"fullWidth":"style-utils_fullWidth__IaoaG"};